export default __webpack_public_path__ + "static/media/taco.518d5750.png";